/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(4),
  },
  description: {
    fontSize: '1.2rem',
    fontWeight: '400',
    maxWidth: '35rem',
    marginTop: theme.spacing(1),
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

function DeleteUserInOrg({ onClick }) {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography variant="h6" component="h6" color="textPrimary" gutterBottom>
        {t('user-management.remove.user.from.organisation')}
      </Typography>
      <Typography variant="h6" color="textSecondary" gutterBottom className={classes.description}>
        {t('user-management.remove.user.from.organisation.description')}
      </Typography>
      <Button
        data-testid="editUserRoles"
        name="editUserRoles"
        type="submit"
        variant="contained"
        color="default"
        className={classes.button}
        startIcon={<CloseIcon />}
        onClick={onClick}
      >
        {t('user-management.remove.user.from.organisation.button')}
      </Button>
    </Box>
  );
}

export default DeleteUserInOrg;
